// extracted by mini-css-extract-plugin
module.exports = {"container":"SideMenu_container__zMU_s"};